module.exports = __webpack_public_path__ + "img/powered-by-sura-hotels.cdc087ec.png";